module.exports = __webpack_public_path__ + "static/img/market.876bfce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/market.png
// module id = rNWL
// module chunks = 0